import React, { Component } from 'react';
import Buttons from '../../../core/Buttons';
import Icon from '../../../core/Icon';
import { Pencil } from '../../../../../assets/images/index';
import { postNewFolder, findNewFolder } from '../../../../utils/apiDepartment';
import ModalMultipleGroups from '../../../views/Common/ModalMultipleGroups';
import {
  StyledLabel,
  StyledInput,
  StyledGroupInput,
  StyledWrapperGroupInput,
  StyledButtonPencil,
  StyledWrapperButtons
} from './style';

export default class NewFolder extends Component {
  constructor(props) {
    super(props);

    const { parentFolderId } = this.props.match.params;
    this.state = {
      newFolder: {
        title: '',
        creationDate: '',
        creationUser: '',
        createSubFolderGroupId: [],
        manageGroupId: [],
        exploreGroupId: [],
        parentFolderId,
        baseContentType: 'FOLDER',
        status: 'PUBLISHED',
        typology: 'INTERNAL'
      },
      validForm: false,
      showModalGroupCreateSubFolder: false,
      showModalGroupManage: false,
      showModalGroupExplore: false
    };
  }

  componentDidMount() {
    const folderId = new URLSearchParams(this.props.location.search).get(
      'folderId'
    );
    if (folderId) {
      findNewFolder(folderId)
        .then(folder => {
          this.setState(prevState => ({
            newFolder: {
              ...prevState.newFolder,
              id: folder.id,
              title: folder.title,
              parentFolderId: folder.parentFolderId,
              createSubFolderGroupId: folder.createSubFolderGroupId,
              exploreGroupId: folder.exploreGroupId,
              manageGroupId: folder.manageGroupId
            },
            showModalGroupCreateSubFolder: false
          }));
        })
        .catch(() => {});
    } else {
      findNewFolder(this.props.match.params.parentFolderId).then(resp => {
        this.setState(prevState => ({
          newFolder: {
            ...prevState.newFolder,
            createSubFolderGroupId: resp.manageGroupId,
            manageGroupId: resp.manageGroupId
          }
        }));
      });
    }
  }

  sendInput = data => {
    const ObjectClean = { ...data, creationDate: new Date() };
    const { history } = this.props;
    const { originPath, breadcrumbData, currentFolder } =
      history.location.state || {};
    const previousPath = originPath;

    postNewFolder(ObjectClean)
      .then(response => {
        history.push({
          pathname: previousPath,
          state: {
            newSubfolderCreated: true,
            newSubfolderInfo: response,
            breadcrumbData,
            currentFolder
          }
        });
      })
      .catch(error => {
        console.error(`Error creating folder${error}`);
      });
  };

  onSaveGroup = (idGroup, folderPermissionType) => {
    switch (folderPermissionType) {
      case 'createSubFolder':
        this.setState(prevState => ({
          newFolder: {
            ...prevState.newFolder,
            createSubFolderGroupId: [idGroup]
          },
          showModalGroupCreateSubFolder: false
        }));
        break;
      case 'manage':
        this.setState(prevState => ({
          newFolder: {
            ...prevState.newFolder,
            manageGroupId: [idGroup]
          },
          showModalGroupManage: false
        }));
        break;
      case 'explore':
        this.setState(prevState => ({
          newFolder: {
            ...prevState.newFolder,
            exploreGroupId: [idGroup]
          },
          showModalGroupExplore: false
        }));
        break;
      default:
    }
  };

  render() {
    const { history } = this.props;
    const {
      newFolder,
      validForm,
      showModalGroupCreateSubFolder,
      showModalGroupManage,
      showModalGroupExplore
    } = this.state;
    const {
      title,
      createSubFolderGroupId,
      manageGroupId,
      exploreGroupId
    } = newFolder;

    return (
      <React.Fragment>
        <StyledLabel>Nombre *</StyledLabel>
        <StyledInput
          id="name"
          name="name"
          type="text"
          value={title}
          onChange={value => {
            this.setState(prevState => ({
              newFolder: {
                ...prevState.newFolder,
                title: value
              }
            }));
            if (value && !validForm) {
              this.setState({ validForm: true });
            } else if (!value && validForm) {
              this.setState({ validForm: false });
            }
          }}
          required
        />
        <StyledLabel>Id grupo con permisos para crear directorio</StyledLabel>
        <StyledWrapperGroupInput>
          <StyledGroupInput
            id="createSubFolderGroupId"
            name="createSubFolderGroupId"
            type="text"
            value={createSubFolderGroupId}
          />
          <StyledButtonPencil>
            <Icon
              hover
              size="m"
              color="main"
              svg={Pencil}
              onClick={() => {
                this.setState({ showModalGroupCreateSubFolder: true });
              }}
            />
          </StyledButtonPencil>
        </StyledWrapperGroupInput>
        <StyledLabel>
          Id grupo con permisos para administrar directorio
        </StyledLabel>
        <StyledWrapperGroupInput>
          <StyledGroupInput
            id="manageGroupId"
            name="manageGroupId"
            type="text"
            value={manageGroupId}
          />
          <StyledButtonPencil>
            <Icon
              hover
              size="m"
              color="main"
              svg={Pencil}
              onClick={() => {
                this.setState({ showModalGroupManage: true });
              }}
            />
          </StyledButtonPencil>
        </StyledWrapperGroupInput>
        <StyledLabel>
          Id grupo con permisos para explorar directorio
        </StyledLabel>
        <StyledWrapperGroupInput>
          <StyledGroupInput
            id="exploreGroupId"
            name="exploreGroupId"
            type="text"
            value={exploreGroupId}
          />
          <StyledButtonPencil>
            <Icon
              hover
              size="m"
              color="main"
              svg={Pencil}
              onClick={() => {
                this.setState({ showModalGroupExplore: true });
              }}
            />
          </StyledButtonPencil>
        </StyledWrapperGroupInput>
        <StyledWrapperButtons>
          <Buttons
            secondary
            className="fr"
            type="submit"
            small
            onClick={() => this.sendInput(newFolder)}
            disabled={!validForm}
          >
            {newFolder.id ? 'Modificar' : 'Crear'} Carpeta
          </Buttons>
          <Buttons
            secondary
            className="fr"
            type="submit"
            small
            onClick={() => history.goBack()}
          >
            Volver
          </Buttons>
        </StyledWrapperButtons>
        {showModalGroupCreateSubFolder && (
          <ModalMultipleGroups
            onClose={() => {
              this.setState({ showModalGroupCreateSubFolder: false });
            }}
            onSaveGroup={this.onSaveGroup}
            folderPermissionType="createSubFolder"
          />
        )}
        {showModalGroupManage && (
          <ModalMultipleGroups
            onClose={() => {
              this.setState({ showModalGroupManage: false });
            }}
            onSaveGroup={this.onSaveGroup}
            folderPermissionType="manage"
          />
        )}
        {showModalGroupExplore && (
          <ModalMultipleGroups
            onClose={() => {
              this.setState({ showModalGroupExplore: false });
            }}
            onSaveGroup={this.onSaveGroup}
            folderPermissionType="explore"
          />
        )}
      </React.Fragment>
    );
  }
}
